// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body[data-scrolltop=on] .exit{display:none}body[data-scrolltop=on] .hover-logout{color:#4ba5de!important}", ""]);
// Exports
module.exports = exports;
